import React, { FC } from 'react';
import { LayoutProps } from 'antd';

import { Layout as BaseLayout } from 'components/ui';

import Content from './Content';
import Header from './Header';

const Layout: FC<LayoutProps> = (props) => (
  <BaseLayout {...props} />
);

export default Object.assign(Layout, { Content, Header });
